import React from 'react';
import { Link } from 'react-router-dom'
import { Fade } from "react-awesome-reveal";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Bg from '../../images/bg/hero-bg01.png'
import Bg2 from '../../images/shape/hero-glassisom.png'
import heroImg from '../../images/hero/hero-img01.png'
import hImg from '../../images/hero/hero-img01.png'
import shape1 from '../../images/shape/hero-shape01.png'
import shape2 from '../../images/shape/hero-shape04.png'

const Hero = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className="hero hero-style-one pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
             <div className="hero-shape">
                <div className="shape shape--one bg_img" style={{ backgroundImage: `url(${Bg2})` }}></div>
                <div className="shape shape--two"><img src={shape1} alt="" /></div>
                <div className="shape shape--three"><img src={shape2} alt="" /></div>
            </div>
            <div className="container">
                <div className="hero_wrap pt-40">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="xb-hero">
                                <Fade direction='up' triggerOnce={'false'} duration={1000} delay={9}>
                                    <div>
                                        <h1 className="xb-item--title wow fadeInUp" data-wow-duration="600ms">Transform Your Business
                                            with <span>Innovate. Scale. Lead.</span>
                                        </h1>
                                    </div>
                                </Fade>
                                <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                                    <div>
                                        <p className="xb-item--content wow fadeInUp" data-wow-delay="100ms"
                                            data-wow-duration="600ms">(Innovative tech built for growth and efficiency)
                                        </p>
                                    </div>
                                </Fade>
                                <Fade direction='up' triggerOnce={'false'} duration={1400} delay={9}>
                                    <div>
                                        <ul className="xb-item--item list-unstyled wow fadeInUp" data-wow-delay="200ms"
                                            data-wow-duration="600ms">
                                            <li><i className="far fa-check"></i> Enhance operations</li>
                                            <li><i className="far fa-check"></i> Drive innovation</li>
                                            <li><i className="far fa-check"></i> Scale with smart tech</li>
                                        </ul>
                                    </div>
                                </Fade>
                                <Fade direction='up' triggerOnce={'false'} duration={1800} delay={9}>
                                    <div>
                                        <div className="xb-btn wow mt-60 fadeInUp" data-wow-delay="300ms" data-wow-duration="600ms">
                                            <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--white_icon">
                                                <div className="xb-item--hidden"><span className="xb-item--hidden-text">Get started now</span></div>
                                                <div className="xb-item--holder">
                                                    <span className="xb-item--text">Get started now</span>
                                                    <div className="xb-item--icon"><i className="far fa-long-arrow-right"></i></div>
                                                    <span className="xb-item--text">Get started now</span>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </Fade>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-right_img pos-rel">
                                <Fade direction='right' triggerOnce={'false'} duration={1200} delay={9}>
                                    <img className="wow fadeInRight" data-wow-duration="600ms" src={heroImg} alt="" />
                                </Fade>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-scroll-down active">
                    <AnchorLink href="#about" className="scrollspy-btn">
                        <span></span>
                        <span></span>
                        <span></span>
                    </AnchorLink>
                </div>
            </div>
        </section>
    )
}

export default Hero;